export enum SearchProfileType {
  DISTRICT = 'DISTRICT',
  RADIUS = 'RADIUS',
  PROJECT = 'PROJECT'
}
